import { buttonDisabled, hideAllElements } from "./helpers.js";
import { initializeReels } from "./slot-machine.js";
import { playSlotSound, playSpinSound, playWinMusic } from "./sound.js";

const elementsToHideWheel = [".modal", ".wheels"];

export function showWinScreen() {
  const spinButton = document.querySelector(".button-spin");
  const modal = document.querySelector(".modal");
  const modalContainer = document.querySelector(".modal__container");

  if (!spinButton || !modal || !modalContainer) return;

  playWinMusic();

  // Сбрасываем анимации перед показом
  modalContainer.style.animation = "none";
  modal.style.animation = "none";

  // Принудительный reflow для сброса анимаций
  void modalContainer.offsetWidth;
  void modal.offsetWidth;

  // Показываем модалку
  modal.style.display = "grid";

  // Запускаем анимации
  modal.style.animation = "showBlock 0.5s forwards";
  modalContainer.style.animation = "modalSequence 2.5s ease-in-out forwards";

  setTimeout(() => {
    // Запускаем анимацию исчезновения с пульсацией
    hideModalWithPulse().then(() => {
      // После полного исчезновения переключаем на слоты
      buttonDisabled(false, "block");
      spinButton.dataset.spin = "slot";
      hideAllElements(elementsToHideWheel);
      initializeReels();
      playSlotSound();
    });
  }, 2500);
}

export function spinGame() {
  const wheelInner = document.querySelector(".wheels__inner");
  if (!wheelInner) return;

  // Проигрываем звук при нажатии на кнопку
  playSpinSound();

  wheelInner.classList.add("spinning");
  buttonDisabled(true, "none");

  setTimeout(() => {
    showWinScreen();
  }, 3000);
}

// Функция для скрытия модалки с пульсацией
function hideModalWithPulse() {
  return new Promise((resolve) => {
    const modal = document.querySelector(".modal");
    const modalContainer = document.querySelector(".modal__container");

    if (!modal || !modalContainer) {
      resolve();
      return;
    }

    // Запускаем анимацию исчезновения
    modal.style.animation = "removeBlock 0.8s forwards";
    modalContainer.style.animation = "hideWithPulse 0.8s ease-in-out forwards";

    // Ждем завершения анимации
    setTimeout(() => {
      modal.style.display = "none";
      // Сбрасываем анимации
      modal.style.animation = "";
      modalContainer.style.animation = "";
      resolve();
    }, 800);
  });
}
